import { uploadConstants } from "../constants/pro";

export const uploadActions = {
  uploadRequest,
  uploadProgress,
  uploadSuccess,
  uploadFailure
};


function uploadRequest (file ) {
  return{
    type: uploadConstants.UPLOAD_REQUEST,
    payload: file,
  }
}

function uploadProgress (file , progress) {
  return{
    type: uploadConstants.UPLOAD_PROGRESS,
    payload: progress,
    meta: { file },
  }
}

function uploadSuccess (file ) {
  return{
    type: uploadConstants.UPLOAD_SUCCESS,
    payload: file,
  }
}

function uploadFailure (file , err) {
  return{
    type: uploadConstants.UPLOAD_FAILURE,
    payload: err,
    error: true,
  }
}
